export enum Pillar2Permissions {
    Admin = 'Pillar2.Admin',
    ProjectView = 'Pillar2.Project.View',
    ProjectCreate = 'Pillar2.Project.Create',
    ProjectEdit = 'Pillar2.Project.Edit',
    ProjectDelete = 'Pillar2.Project.Delete',
    ProjectDataDelete = 'Pillar2.Project.Data.Delete',
    ProjectDataExport = 'Pillar2.Project.Data.Export',
    ProjectProcessFlowSettingsEdit = 'Pillar2.Project.ProcessFlowSettings.Edit',
    ProjectDataEdit = 'Pillar2.Project.Data.Edit',
    ProjectDataEditImport = 'Pillar2.Project.Data.Edit.Import',
    ProjectReportView = 'Pillar2.Project.Report.View',
    ProjectReportCreate = 'Pillar2.Project.Report.Create',
    ProjectCurrenciesEdit = 'Pillar2.Project.Currencies.Edit',
    ProjectFilingObligationView = 'Pillar2.Project.FillingObligation.View',
    ProjectFilingObligationEdit = 'Pillar2.Project.FillingObligation.Edit',
    ProjectPreviousReportingYearView = "Pillar2.Project.PreviousReportingYear.View",
    ProjectPreviousReportingYearEdit = "Pillar2.Project.PreviousReportingYear.Edit",
    SubmissionView = 'Pillar2.Submission.View',
    SubmissionCreate = 'Pillar2.Submission.Create',
    SubmissionEdit = 'Pillar2.Submission.Edit',
    SubmissionRevokeReview = 'Pillar2.Submission.RevokeReview',
    SubmissionSubmit = 'Pillar2.Submission.Submit',
    SubmissionRevokeReadyForSubmission = 'Pillar2.Submission.RevokeReadyForSubmission',
    SubmissionDelete = 'Pillar2.Submission.Delete',
    SubmissionReview = 'Pillar2.Submission.Review',
    SubmissionJsonView = 'Pillar2.Admin.SubmissionJsonView',
}
